import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getPushSubscriptionState, getPushSubscriptions } from './selectors';
import { togglePushSubscription, updatePushSubscriptions, displayPushNotificationsModal } from './actions';
import { PushSubscriptionState } from './types';
import { useAction } from '@wix/da-hooks/pkg/useAction';
import { setPWABannerCookie } from '../../PWABanner/usePWABanner';
export function usePushSubscription() {
    const state = useSelector(getPushSubscriptionState);
    const dispatch = useDispatch();
    const toggle = useCallback(()=>{
        dispatch(togglePushSubscription());
        // dismiss and set cookie on the PWA notifications banner
        // from showing again after the user interacts with push notifications
        setPWABannerCookie();
    }, [
        dispatch
    ]);
    return {
        state,
        isBlocked: typeof window !== 'undefined' && window.Notification && window.Notification.permission === 'denied',
        isSubscribed: state === PushSubscriptionState.SUBSCRIBED,
        canToggle: [
            PushSubscriptionState.SUBSCRIBED,
            PushSubscriptionState.READY_TO_SUBSCRIBE
        ].includes(state),
        toggle,
        manage: useAction(displayPushNotificationsModal)
    };
}
// get a PushSubscriptions map to see which notifications the user subscribed to
export function usePushSubscriptions() {
    const dispatch = useDispatch();
    const subscriptions = useSelector(getPushSubscriptions);
    const setSubscriptions = useCallback((updatedSubscriptions)=>{
        dispatch(updatePushSubscriptions(updatedSubscriptions));
    }, [
        dispatch
    ]);
    return [
        subscriptions,
        setSubscriptions
    ];
}

//# sourceMappingURL=hooks.js.map